import React, { FC, useEffect, useState } from "react";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import { Box, iconButtonClasses, Typography } from "@mui/material";
import DownloadIcon from "../../assets/Icons/replenishment/DownloadIcon.svg";
import CrossIcon from "../../assets/Icons/replenishment/CrossIcon.svg";

function LinearProgressWithLabel(
  props: LinearProgressProps & { value: number }
) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          sx={{ fontSize: "14px", color: "rgba(13, 71, 161, 1)" }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

interface AlertProps {
  title: string;
  completeTitle: string;
  completeSubTitle: string;
  loading: boolean;
  close: () => void;
}

export const Alerts: FC<AlertProps> = ({
  title,
  completeTitle,
  completeSubTitle,
  loading,
  close,
}) => {
  const [progress, setProgress] = useState(40);
  const [isComplete, setIsComplete] = useState(false);
  return (
    <div
      style={{
        width: "453px",
        //height: "72px",
        background: "#BBDEFB",
        borderRadius: "4px",
        display: "flex",
        flexDirection: "row",
        border: "1px solid rgba(25, 118, 210, 0.12)",
        padding: "12px 52px 17px 16px",
        gap: "16px",
        position: "relative",
        alignItems: "center",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <img src={DownloadIcon} />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: "1",
          justifyContent: "center",
        }}
      >
        <p style={{ fontSize: "16px" }}>{!loading ? completeTitle : title}</p>
        {loading && (
          //   <div
          //     style={{ display: "flex", flexDirection: "row", fontSize: "12px" }}
          //   >
          //     <p style={{ color: "rgba(117, 117, 117, 1)", margin: "8px" }}>
          //       {completeSubTitle}
          //     </p>
          //   </div>
          // ) : (
          <LinearProgress />
        )}
      </div>
      <img
        style={{ position: "absolute", top: "8px", right: "8px" }}
        src={CrossIcon}
        className="icon"
        onClick={close}
      />
    </div>
  );
};

export default Alerts;
